// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"407c6cd7","269":"365698b3","324":"46555db0","462":"68e3911c","480":"5a6d5731","528":"7d7d5ad4","529":"32a314d3","591":"611d4d99","671":"3acc6053","705":"0e8db8b0","872":"0711766e","925":"609e0a25","937":"326506c0"}[chunkId] + ".chunk.js";
};